export default {
      id: "arrow-down-usage",
      viewBox: "0 0 16 16",
      url: "assets/" + "sprite.svg#arrow-down-usage",
      toString: function () {
        return this.url;
      }
    }